document.addEventListener("turbo:load", () => {

  document.addEventListener("click", (e) => {
    const row = e.target.closest("tr[data-wage-row]");
    if (!row) return;

    const table = document.getElementById("wagesTable");
    if (!table) return;

    table
        .querySelectorAll("tr[data-wage-row]")
        .forEach(tr => tr.classList.remove("selected"));

    row.classList.add("selected");

    Turbo.visit(row.dataset.wageUrl, { frame: "wage-form" });
  });

document.addEventListener("click", (e) => {
    const link = e.target.closest('a[data-turbo-frame="wage-form"]');

    const table = document.getElementById("wagesTable")

    if (link && !link.closest("tr[data-wage-row]")) {
      table
          .querySelectorAll("tr[data-wage-row]")
          .forEach((tr) => tr.classList.remove("selected"));
    }
  })
});
